import { Box, Typography, makeStyles } from "@material-ui/core";
import { ConsultantOpportunityStatsDataFragment } from "@bonliva-crm/graphql";
import { StatBox } from "./stat-box";
import { useLocale } from "@hooks";

type Props = {
  title: string;
  loading: boolean;
  data: ConsultantOpportunityStatsDataFragment | null;
};

export function StatsRow(props: Props) {
  const { locale } = useLocale();
  const classes = useStyles();

  return (
    <Box>
      <Box className={classes.statsTitle}>
        <Typography variant="h3">{props.title}</Typography>
      </Box>

      {props.loading && <p>Loading...</p>}

      {!props.loading && props.data && (
        <Box className={classes.statRow}>
          <StatBox
            background="#f6f3f0"
            title={locale.presentedWeeks}
            value={props.data.presentedWeeks}
          />
          <StatBox
            background="#ece5e1"
            title={locale.wonWeeks}
            value={props.data.wonWeeks}
          />
          <StatBox
            background="#e2efff"
            title={locale.lostWeeks}
            value={props.data.lostWeeks}
          />
          <StatBox
            background="#fcebe0"
            title={locale.openWeeks}
            value={props.data.openWeeks}
          />
        </Box>
      )}
    </Box>
  );
}

const useStyles = makeStyles({
  statsTitle: {
    marginTop: 16
  },
  statRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    marginTop: "20px",
    gap: 16
  }
});
